import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import LoanInstalmentsAnalytics from '@/components/loans/LoanInstalmentsAnalytics';
import LoanInstalmentsRecords from '@/components/loans/LoanInstalmentsRecords';
import { Calendar } from 'lucide-react';

export default function LoanInstalments() {
    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <Calendar className="h-8 w-8" />
                    <h1 className="text-4xl font-semibold tracking-tight">Advance Instalments</h1>
                </div>
                <p className="text-muted-foreground">Advance payment schedules.</p>
            </div>

            <Tabs defaultValue="analytics" className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <LoanInstalmentsAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <LoanInstalmentsRecords />
                </TabsContent>
            </Tabs>
        </div>
    );
}
